<template>
  <div className="animated">
    <div class="animated fadeIn">
      <b-modal
        id="modal-lg"
        ref="infoModal"
        centered
        size="lg"
        title="Detalle de guia de despacho"
        @ok="waybill = null"
        ok-only
      >
        <div class="text-center">
          <b-spinner v-if="!waybill" label="Spinning"></b-spinner>
        </div>
        <report v-if="waybill" :waybill="waybill"></report>
      </b-modal>

      <email-modal
        :to="to"
        :cc="cc"
        :bcc="bcc"
        :waybill_id="waybill_id"
        :type="1"
        :subject="subject"
        :msg="msg"
        @onSend="refreshTable"
        ref="email"
      ></email-modal>
      <b-row class="my-2">
        <b-col>
          <h1 class="text-uppercase font-weight-bold">Listado de Recepciones</h1>
        </b-col>
        <b-col>
          <div>
            <b-form>
              <b-row>
                <b-col>
                  <label for="monthSelect">Mes</label>
                  <b-form-select
                    id="monthSelect"
                    v-model="selected.month"
                    :plain="true"
                    :options="selectOptions.months"
                    value="Seleccione..."
                  >
                  </b-form-select>
                </b-col>
                <b-col>
                  <label for="yearSelect">Año</label>
                  <b-form-select
                    id="yearSelect"
                    v-model="selected.year"
                    :plain="true"
                    :options="selectOptions.years"
                    value="Seleccione..."
                  >
                  </b-form-select>
                </b-col>
              </b-row>
            </b-form>
          </div>
        </b-col>
      </b-row>
      <v-server-table :url="url" :columns="columns" :options="options" :theme="theme" ref="table" id="dataTable">
        <template slot="condition" slot-scope="props">
          <b-badge pill :variant="getBadge(props.row.condition)">{{ props.row.condition }}</b-badge>
        </template>
        <template slot="h___total_pallets">
          Pallets Totales <br />
          <b-badge>{{ sumColumn("_total_pallets") | formatNumber }}</b-badge>
        </template>
        <template slot="h___total_quantity">
          Cantidad Total <br />
          <b-badge>{{ sumColumn("_total_quantity") | formatNumber }}</b-badge>
        </template>
        <template slot="h___total_net_kilograms">
          KN Totales <br />
          <b-badge>{{ sumColumn("_total_net_kilograms") | formatNumber }}</b-badge>
        </template>
        <template slot="waybill_status" slot-scope="props">
          <div style="text-align: right" class="text-uppercase">
            <!-- Si esta cerrada y es staff -->
            <a href="" @click.prevent="openWaybill(props.row.id)">
              <b-badge
                pill
                :variant="getBadge(props.row.waybill_status)"
                v-if="$store.state.user.STAFF && props.row.waybill_status === 'cerrada'"
              >
                {{ props.row.waybill_status }}
              </b-badge>
            </a>

            <!-- Si esta cerrada y no es Staff -->
            <b-badge
              pill
              :variant="getBadge(props.row.waybill_status)"
              v-if="!$store.state.user.STAFF && props.row.waybill_status === 'cerrada'"
            >
              {{ props.row.waybill_status }}
            </b-badge>

            <!-- Si esta abierta -->
            <b-badge pill :variant="getBadge(props.row.waybill_status)" v-if="props.row.waybill_status != 'cerrada'">
              {{ props.row.waybill_status }}
            </b-badge>
          </div>
        </template>
        <template slot="afterFilter">
          <tr class="VueTables__no-results">
            <b-button @click.prevent="resetFilters">Limpiar filtro</b-button>
            <download-excel
              class="btn"
              :fetch="fetchData"
              :fields="json_fields"
              worksheet="Procesos"
              :name="name"
              :before-generate="startDownload"
              :before-finish="finishDownload"
            >
              <b-button>Descargar</b-button>
            </download-excel>
          </tr>

          <tr v-if="loading" class="VueTables__no-results">
            <b-spinner v-if="loading" variant="primary" class="ml-2 mt-1" small label="Small Spinner"></b-spinner>
          </tr>
        </template>
        <template slot="child_row" slot-scope="props">
          <div><b>Nota productor:</b> {{ props.row.note }}</div>
          <div><b>Nota interna:</b> {{ props.row.internal_note }}</div>
        </template>
        <div slot="_total_net_kilograms" slot-scope="props">
          <div style="text-align: right">
            {{ props.row._total_net_kilograms }}
          </div>
        </div>
        <div slot="_total_pallets" slot-scope="props">
          <div style="text-align: right">{{ props.row._total_pallets }}</div>
        </div>
        <div slot="_total_quantity" slot-scope="props">
          <div style="text-align: right">{{ props.row._total_quantity }}</div>
        </div>
        <div slot="number" slot-scope="props">
          <div style="text-align: right">{{ props.row.number }}</div>
        </div>
        <div slot="interplanta" slot-scope="props">
          <div class="text-center" v-if="props.row.interplanta">
            <b-badge :variant="getInterplantaBadge(props.row.interplanta)" v-if="props.row.interplanta === 'recibida'">
              <i class="fa fa-lg fa-check"></i>
            </b-badge>
            <b-badge :variant="getInterplantaBadge(props.row.interplanta)" v-else>
              <i class="fa fa-lg fa-truck"></i>
            </b-badge>
          </div>
        </div>
        <div slot="waybill_date" slot-scope="props">
          <div style="text-align: right">{{ props.row.waybill_date }}</div>
        </div>
        <div slot="client_customer.name" slot-scope="props">
          {{ props.row.client_customer_name }}
        </div>
        <div slot="company.name" slot-scope="props">
          {{ props.row.company_name }}
        </div>
        <div class="text-right" slot="actions" slot-scope="props">
          <a href="" @click.prevent="getCompleteWaybill(props.row.id)" class="fa fa-lg mx-1 fa-search text-primary"></a>
          <a
            href=""
            @click.prevent="downloadWithAxios(props.row.id, props.row.number)"
            class="fa fa-lg mx-1 fa-file-pdf-o text-primary"
          ></a>
          <a
            v-if="props.row.waybill_status != 'enviada' && props.row.waybill_status != 'abierta'"
            href=""
            @click.prevent="emailModal(props.row)"
            class="fa fa-lg mx-1 fa-send text-primary"
          >
          </a>
          <router-link
            v-if="props.row.waybill_status === 'abierta'"
            :to="{ path: '/recepcion/editar/' + props.row.id }"
            class="fa fa-lg mx-1 fa-edit text-primary"
          ></router-link>
          <!--            <a @click.prevent="deleteWaybill(props.row.id)" href="" class="fa fa-lg fa-trash text-danger"></a>-->
        </div>
      </v-server-table>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";
import JsonExcel from "vue-json-excel";
import moment from "moment";
import numeral from "numeral";
import locales from "numeral/locales";
import Report from "./Report.vue";
import emailModal from "../reusable/emailModal";

numeral.locale("es");
window.axios = require("axios");

import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

var d = new Date();

Vue.use(ServerTable);
Vue.component("downloadExcel", JsonExcel);

export default {
  name: "DataTable",
  components: {
    ServerTable,
    emailModal,
    Report
  },
  created() {
    this.getProducts();
  },
  mounted() {
    Event.$on("vue-tables.loading", () => {
      this.loading = true;
    });

    Event.$on("vue-tables.loaded", () => {
      this.loading = false;
    });
    if (this.$store.state.user.scope.includes("se-le-agrega-columna-interplanta-en-lista-de-guias")) {
      // Push before the actions column
      this.columns.splice(this.columns.length - 1, 0, "interplanta");
    }

    this.loadYear();
    this.getSelectionSet();
  },
  data() {
    return {
      loading: true,
      to: null,
      cc: null,
      bcc: null,
      subject: null,
      msg:
        "Estimado Productor, \n" +
        "Nos es grato informarle que hemos recibido su fruta. Por favor revise en archivo adjunto los detalles de nuestra recepción.\n" +
        "\n" +
        "Atte.,",
      waybill: null,
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      json_fields: {
        Exportadora: "client_customer.name_name",
        Numero: "number",
        Productor: "company_name.name",
        "Fecha Guia": "waybill_date",
        Pallets: "_total_pallets",
        Recip: "_total_quantity",
        "Total KN": {
          field: "_total_net_kilograms",
          callback: (value) => {
            return value.replace(".", ",");
          }
        },
        Estatus: "waybill_status",
        Nota: "note",
        "Nota Interna": "internal_note"
      },
      columns: [
        "client_customer.name",
        "plant_name",
        "waybill_date",
        "number",
        "company.name",
        "_total_pallets",
        "_total_quantity",
        "_total_net_kilograms",
        "waybill_status",
        "actions"
      ],
      selected: {
        product: "",
        product_type: "",
        condition: "",
        month: d.getMonth() + 1,
        year: d.getFullYear()
      },
      selectOptions: {
        products: [],
        product_types: [],
        months: [
          { value: 1, text: "Enero" },
          { value: 2, text: "Febrero" },
          { value: 3, text: "Marzo" },
          { value: 4, text: "Abril" },
          { value: 5, text: "Mayo" },
          { value: 6, text: "Junio" },
          { value: 7, text: "Julio" },
          { value: 8, text: "Agosto" },
          { value: 9, text: "Septiembre" },
          { value: 10, text: "Octubre" },
          { value: 11, text: "Noviembre" },
          { value: 12, text: "Diciembre" }
        ],
        years: []
      },
      data: [],
      productSet: [],
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
      options: {
        debounce: 800,
        // skin: "table table-sm table-hover border-0",
        responseAdapter: function (resp) {
          const results = resp.data.results;
          const items = [];
          for (let key in results) {
            const item = results[key];
            results[key].waybill_date = moment(results[key].waybill_date).format("DD-MM-YYYY");
            results[key].total_kilograms = numeral(parseFloat(results[key].total_kilograms));
            items.push(item);
          }

          return {
            data: items,
            count: resp.data.count
          };
        },
        texts: {
          noResults: "No se encontraron registros.",
          filter: "Filtrar:",
          filterBy: "Filtrar por {column}",
          count: " ",
          filterPlaceholder: "Buscar...",
          columns: "Columnas",
          limit: "Registros:",
          loading: "Cargando...",
          defaultOption: "Selecione {column}"
        },
        perPage: 25,
        perPageValues: [15, 25, 50, 100],
        // columnsDropdown: true,
        filterByColumn: true,
        filterable: ["client_customer.name", "plant_name", "waybill_date", "number", "company.name", "waybill_status"],
        listColumns: {
          waybill_status: [
            { text: "abierta", id: "abierta" },
            { text: "cerrada", id: "cerrada" },
            { text: "enviada", id: "enviada" }
          ]
          // "client_customer.name": []
        },
        headings: {
          number: "Numero",
          "company.name": "Productor",
          "client_customer.name": "Exportadora",
          plant_name: "Planta de recepción",
          contact_name: "Contacto",
          waybill_date: "Fecha Guia",
          actions: "Acciones",
          _total_net_kilograms: "Kg Netos Totales",
          _total_pallets: "Pallets Totales",
          _total_quantity: "Cantidad Total",
          waybill_status: "Status"
        },
        sortable: [],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          dropdown: false,
          chunk: 10
        }
      }
    };
  },
  watch: {
    selected: {
      handler(val) {
        this.getProductSet(this.selected.product);
      },
      deep: true
    }
  },
  computed: {
    name() {
      return "Recepciones " + moment(Date.now()).format("YYYYMMDD h:mm") + ".xls";
    },
    sumMarkedKilograms() {
      let total = 0;
      // total += this.data.reduce((acc, item) => acc + item.total_kilograms.value(), 0);
      total = numeral(total);
      return total;
    },
    url() {
      return (
        "/api/v1/waybill/received_waybills/?" +
        "condition=" +
        this.selected.condition +
        "&product_type=" +
        this.selected.product_type +
        "&variety__product=" +
        this.selected.product +
        "&arrival_month=" +
        this.selected.month +
        "&arrival_year=" +
        this.selected.year
      );
    }
  },
  methods: {
    getInterplantaBadge(status) {
      if (status === "en tránsito") {
        return "warning";
      } else if (status === "recibida") {
        return "success";
      } else {
        return "primary";
      }
    },
    sumColumn(column) {
      let total = 0;
      const data = this.$refs.table;
      if (data) {
        total += data.data.reduce((acc, item) => acc + parseFloat(item[column]), 0);
      }
      return total;
    },
    getSelectionSet() {
      this.$axios
        .get("/api/v1/client/process_select_input/")
        .then((res) => {
          const client_customers = res.data.client_customers;
          for (let idx in client_customers) {
            const item = {
              id: client_customers[idx]["value"],
              text: client_customers[idx]["text"]
            };
            this.options.listColumns["client_customer.name"].push(item);
          }
        })
        .catch((error) => console.log(error));
    },
    resetFilters() {
      for (var key in this.$refs["table"].query) {
        this.$refs["table"].query[key] = "";
      }
      this.$refs["table"].refresh();
    },
    refreshTable() {
      this.$refs.table.refresh();
    },
    openWaybill(a) {
      this.$axios
        .put("/api/v1/waybill/" + a + "/open_waybill/")
        .then((res) => {
          this.$refs["table"].refresh();
        })
        .catch((error) => console.log(error));
    },
    emailModal(obj) {
      this.$axios({
        method: "get",
        url: "/reports/arrival_emails/" + obj.company
      })
        .then((res) => {
          miniToastr[res.data.color](res.data.msg, "");
          this.to = res.data.emails.to.join();
          this.cc = res.data.emails.cc.join();
          this.bcc = res.data.emails.bcc.join();
        })
        .catch((error) => {});
      this.waybill_id = obj.id;
      this.subject = "Notificación de recepción G" + obj.number;
      this.$bvModal.show("email-modal");
    },
    forceFileDownload(response, a) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Guia de despacho #" + a + ".pdf"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    downloadWithAxios(a, b) {
      this.$axios({
        method: "get",
        url: "/reports/arrival_pdf/" + a,
        responseType: "arraybuffer"
      })
        .then((response) => {
          this.forceFileDownload(response, b);
          miniToastr.success("Pdf generado con éxito.", "Mensaje:");
        })
        .catch((error) => {
          miniToastr.error("Problemas al generar pdf", "Error:");
          console.log(error);
        });
    },
    async fetchData() {
      const response = await this.$axios.get(this.url);
      return response.data.results;
    },
    startDownload() {
      this.loading = true;
    },
    finishDownload() {
      this.loading = false;
    },

    getCompleteWaybill(a) {
      this.$refs.infoModal.show();
      this.$axios
        .get("/api/v1/waybill/" + a + "/waybill_complete/")
        .then((res) => {
          this.waybill = res.data;
        })
        .catch((error) => console.log(error));
    },
    getBadge(status) {
      return status === "abierta" ? "secondary" : status === "cerrada" ? "dark" : "success";
    },
    getDaystayBadge(daystay) {
      return daystay >= 10 ? "danger" : daystay >= 5 ? "warning" : daystay >= 3 ? "success" : "primary";
    },
    getProducts() {
      this.$axios
        .get("/production/get_products/")
        .then((res) => {
          // console.log(res)
          const data = res.data.data;
          const products = [];
          for (let key in data) {
            const product = data[key];
            products.push(product);
          }
          this.selectOptions.products = products;
        })
        .catch((error) => console.log(errors));
    },
    getProductSet(a) {
      this.$axios
        .get("/production/get_product_set/" + a)
        .then((res) => {
          this.selectOptions.product_types = res.data.product_types;
        })
        .catch((error) => (this.selected.product_type = ""));
    },
    deleteWaybill(a) {
      this.$axios
        .delete("/api/v1/waybill/" + a + "/")
        .then((res) => {
          if (res.data.status == 1) {
            miniToastr.success("Guía eliminada con exito", "");
            this.$refs.table.refresh();
          }

          if (res.data.status == 2) {
            miniToastr.info("Imposible eliminar la guia, tiene contenidos procesados", "");
          }
        })
        .catch((error) => console.log(error));
    },
    loadYear() {
      for (let ano = 2017; ano <= d.getFullYear(); ano++) {
        this.selectOptions.years.push({ value: ano, text: ano });
      }
    }
  }
};
</script>

<style>
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }
  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
